export default "__VITE_ASSET__ead2edb4__"